import {gql} from "@apollo/client";
import filterDataGql, {executeQueryUtil} from "../utils/gqlUtil";
import apolloClient from "../apolloClient/ApolloClient";

const common = `
    id
    name
`

export const getDashBoardsQuery = (userId) => {

  return gql`
    query {
      getDashBoards(userId: "${userId}") {
        ${common}
      }
    }
  `;
}

export const getDashBoardQuery = (userId, chartBoardItemId) => {

    return gql`
    query {
      getDashBoard(userId: "${userId}", dashBoardId: "${chartBoardItemId}") {
        ${common}
      }
    }
  `;
}

export const createDashBoardMutation = (userId, data) => {
    var dataString = filterDataGql(data, ["createdAt", "creationDate", "updateDate", "createdAt"],
        [] );
    return gql`mutation {
      addDashBoard(userId: "${userId}", data: ${dataString}) {
        ${common}
      }
  }
  `;
}

export const updateDashBoardMutation = (userId, data) => {
    var dataString = filterDataGql(data, ["createdAt", "creationDate", "updateDate", "createdAt"],
        ["groupBy"] );
    return gql`mutation {
      updateDashBoard(userId: "${userId}", data: ${dataString}) {
        ${common}
      }
  }
  `;
}

export const bulkDeleteDashBoardMutation = (userId, ids) => {
    var idsString =  JSON.stringify(ids);

    return gql`
    mutation {
      bulkDeleteDashBoard(userId: "${userId}", dashBoardIds: ${idsString}) {
        ids
      }
    }
  `;
}

export const addDataDashBoardToCache = async (userId, datas) => {
    if (!datas) {
        return
    }
    const query = getDashBoardsQuery(userId);
    const res = await executeQueryUtil(query);

    if (res) {
        await apolloClient.writeQuery({
            query: query,
            data: {
                getDashBoards: [...res.data.getDashBoards, ...datas]
            },
        });
    }
}

export const deleteDashBoardFromCache = async (userId, ids) => {
    const query = getDashBoardsQuery(userId);
    const res = await executeQueryUtil(query);
    const newData = res.data.getDashBoards.filter(item =>
        !ids.includes(item.id)
    )

    if (res) {
        await apolloClient.writeQuery({
            query: query,
            data: {
                getDashBoards: [...newData]
            },
        });
    }
}






